import React, { useState, useEffect } from "react";
import clsx from "clsx/lite";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation } from "swiper/modules";
import ButtonLink from "components/button-link";
import ProductCard from "./product-card";
import { useCustomer } from "hooks/useStore";
import { useInView } from "react-intersection-observer";
import { trackViewItemList } from "analytics";
import { ReactComponent as Arrow } from "svgs/arrow-right.svg";
import Link from "components/link";

const MultipleCollections = ({ data }) => {
	const { relatedCollections = [], collectionsDesktop = [], splitDesignByDevice, title, itemsToShow = 8, settings, cardStyle, 
		cardStyleDesktop, slider, showGridOnMobile, } = data || {};
	const collections = splitDesignByDevice ? collectionsDesktop : relatedCollections;
	const [activeIndex, setActiveIndex] = useState(0);
	const activeCollection = collections[activeIndex];
	const collection = activeCollection?.collection;
	const products = collection?.products || [];
	const { ref, inView } = useInView({ threshold: 0, triggerOnce: true });
	const customer = useCustomer();

	const swiperSettings = {
		modules: [Navigation],
		navigation: true,
		slidesPerView: 1.3,
		spaceBetween: 12,
		breakpoints: {
			640: { slidesPerView: 2 },
			768: { slidesPerView: 3 },
			1024: { slidesPerView: 4 },
		},
	};

	const buttonData = activeCollection?.collection ? {
		url: `collections/${activeCollection.handle}`,
		text: `Shop ${activeCollection.title || activeCollection.collection.title}`,
	} : null;

	useEffect(() => {
		if (inView) {
			trackViewItemList(products, { title, handle: location.pathname }, customer);
		}
	}, [inView, activeIndex]);


	return (
		<div ref={ref} className="w-full flex flex-col gap-2 md:gap-3">
			<h3
				className={clsx(
					"capitalize font-header",
					settings?.useLatoTitleFont && "text-3xl lg:text-5xl font-base font-medium",
					slider ? "text-left !mr-auto text-xxl " : "text-center"
				)}
			>
				{title}
			</h3>

			<div className="flex !justify-start !items-start no-scrollbar gap-7 py-3 overflow-x-auto whitespace-nowrap">
				{collections.map((item, idx) => (
					<button
						key={item.collection.id}
						className={clsx(
							"rounded-full font-header sm:text-xl transition !text-left inline-block",
							idx === activeIndex ? "text-deepBeige underline" : "text-black"
						)}
						onClick={() => setActiveIndex(idx)}
					>
						{item.title}
					</button>
				))}

  
				<Link
					to={"/collections/all-modern-light-fixtures"}
					className="font-header sm:text-xl text-black flex justify-center items-center sm:gap-2 gap-1 inline-block"
				>	
					Shop All
					<Arrow className="sm:scale-100 scale-75 fill-black" />
				</Link>
			</div>

			<div className="w-full">
				{slider ? (
					<Swiper {...swiperSettings} className="flex w-full overflow-auto no-scrollbar">
						{products.slice(0, itemsToShow).map((product, index) => (
							<SwiperSlide key={product.id || index}   className="w-1/2 md:w-1/3 lg:w-1/4">
								<div className="w-full">
									<ProductCard product={product} index={index}   cardStyle={cardStyleDesktop ?? cardStyle}
									/>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				) : (
					<div className="w-full text-center overflow-hidden">
						<ul
							className={clsx(
								"featured-collection",
								itemsToShow === 4 ? "flex lg:inline-grid" : "featured-collection-large",
								settings?.isFluid && "horizontal-padding",
								showGridOnMobile && "grid-featured-collection"
							)}
						>
							{products.slice(0, itemsToShow).map((product, index) => (
								<li key={product.id || index} className="w-fit pb-2 md:pb-0">
									<ProductCard product={product} cardStyle={cardStyleDesktop ?? cardStyle} />
								</li>
							))}
						</ul>
					</div>
				)}
			</div>
			{buttonData && (
				<div className="w-full flex pt-5 justify-center" >
					<ButtonLink data={buttonData} className="btn-secondary" />
				</div>
			)}
		</div>
	);
};

export default MultipleCollections;
